
const apiURL = "https://redtoothauctionapi.azurewebsites.net"
//const apiURL = "https://localhost:44320"

export { apiURL };